(() => {
  const init = root => {
    if (root.dataset.fmvReady) return;
    root.dataset.fmvReady = 'true';
    const q = key => root.querySelector(`[data-fmv="${key}"]`);
    const mk=q('make'), md=q('model'), sr=q('series'), yr=q('year'), go=q('go'), note=q('note');
    const makes=JSON.parse(q('data').textContent), messages=JSON.parse(q('messages').textContent);
    const modelNames=makes.flatMap(m=>m.models.map(x=>m.name+' '+x.name)).sort((a,b)=>b.length-a.length);
    const collections=(window.Shopify?.routes?.root || '/')+'collections/';
    const cache=new Map();
    let records=[], generation=0, yearRoutes=new Map();
    const fill=(select,items,placeholder,keep='')=>{
      select.replaceChildren(new Option(placeholder,''),...items.map(x=>new Option(x.label,x.value)));
      select.disabled=!items.length;
      if(items.some(x=>x.value===keep))select.value=keep;
    };
    const currentMake=()=>makes.find(m=>m.handle===mk.value);
    const currentModel=()=>currentMake()?.models.find(m=>m.handle===md.value);
    const fullModel=()=>currentModel()?currentMake().name+' '+currentModel().name:'';
    const modelForSeries=tag=>modelNames.find(m=>tag.slice(7)===m||tag.slice(7).startsWith(m+' '));
    const seriesFor=record=>record.tags.filter(t=>t.startsWith('Series_')&&modelForSeries(t)===fullModel()&&t.length>7+fullModel().length);
    const matchedRecords=()=>sr.value?records.filter(p=>p.tags.includes(sr.value)):records;
    const escapeRx=s=>s.replace(/[.*+?^${}()|[\]\\]/g,'\\$&');
    const yearEntries=record=>{
      const prefix=sr.value?sr.value.slice(7):fullModel();
      const direct=new RegExp('^Fitment_'+escapeRx(prefix)+'_(\\d{4})$');
      const modelPattern=new RegExp('^Fitment_'+escapeRx(fullModel())+'_(\\d{4})$');
      let fit=record.tags.filter(t=>direct.test(t));
      if(!fit.length&&sr.value)fit=record.tags.filter(t=>modelPattern.test(t));
      if(!fit.length&&!sr.value)fit=record.tags.filter(t=>{
        const match=t.match(/^Fitment_(.+)_(\d{4})$/);
        return match&&modelNames.find(m=>match[1]===m||match[1].startsWith(m+' '))===fullModel();
      });
      if(fit.length)return fit.map(t=>({year:t.slice(-4),tag:t}));
      if(record.tags.some(t=>t.startsWith('Fitment_')))return [];
      return record.tags.filter(t=>/^Year_\d{4}$/.test(t)).map(t=>({year:t.slice(5),tag:t}));
    };
    const updateYears=()=>{
      yearRoutes=new Map();
      for(const record of matchedRecords())for(const entry of yearEntries(record)){
        if(!yearRoutes.has(entry.year))yearRoutes.set(entry.year,new Map());
        const routes=yearRoutes.get(entry.year);routes.set(entry.tag,(routes.get(entry.tag)||0)+1);
      }
      fill(yr,[...yearRoutes.keys()].sort().reverse().map(y=>({label:y,value:y})),messages.all_years,yr.value);
    };
    const loadModel=async()=>{
      const version=++generation;records=[];note.textContent='';
      fill(sr,[],messages.all_series);fill(yr,[],messages.all_years);
      const model=currentModel();if(!model)return;
      note.textContent=messages.loading;
      try{
        if(!cache.has(model.handle)){
          const all=[];
          for(let page=1,pages=1;page<=pages;page++){
            const url=new URL(collections+encodeURIComponent(model.handle),location.origin);
            url.searchParams.set('section_id','vehicle-finder-data');url.searchParams.set('page',String(page));
            const response=await fetch(url,{headers:{Accept:'text/html'}});
            if(!response.ok)throw new Error('Unavailable');
            const html=new DOMParser().parseFromString(await response.text(),'text/html');
            const data=JSON.parse(html.querySelector('[data-fmv-products]').textContent);
            pages=data.pages||1;if(pages>20)throw new Error('Collection too large');
            all.push(...data.products);
          }
          cache.set(model.handle,all);
        }
        if(version!==generation)return;
        records=cache.get(model.handle);
        const series=[...new Set(records.flatMap(seriesFor))].sort();
        fill(sr,series.map(tag=>({value:tag,label:tag.slice(8+fullModel().length)})),messages.all_series);
        updateYears();note.textContent='';
      }catch(error){if(version===generation)note.textContent=messages.optional_unavailable;}
    };
    fill(mk,makes.map(m=>({value:m.handle,label:m.name})),messages.select_make);
    mk.addEventListener('change',()=>{
      generation++;records=[];note.textContent='';
      fill(md,(currentMake()?.models||[]).map(m=>({value:m.handle,label:m.name})),messages.select_model);
      fill(sr,[],messages.all_series);fill(yr,[],messages.all_years);go.disabled=!mk.value;
    });
    md.addEventListener('change',loadModel);
    sr.addEventListener('change',()=>{updateYears();note.textContent='';});
    yr.addEventListener('change',()=>{note.textContent='';});
    const tagHandle=tag=>tag.toLowerCase().replace(/[^a-z0-9_\s-]/g,'').trim().replace(/\s+/g,'-').replace(/-+/g,'-');
    root.querySelector('[data-fmv-form]').addEventListener('submit',event=>{
      event.preventDefault();if(!mk.value)return;
      const tags=sr.value?[sr.value]:[];
      if(yr.value){
        const routes=yearRoutes.get(yr.value);
        if(!routes?.size){note.textContent=messages.unavailable;return;}
        tags.push([...routes].sort((a,b)=>b[1]-a[1])[0][0]);
      }
      if(tags.length&&!records.some(p=>tags.every(tag=>p.tags.includes(tag)))){note.textContent=messages.unavailable;return;}
      location.href=collections+encodeURIComponent(md.value||mk.value)+(tags.length?'/'+tags.map(tagHandle).join('+'):'');
    });
    go.disabled=!mk.value;
  };
  document.querySelectorAll('.fmv').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.fmv').forEach(init));
})();
